// The schedule cadences the UI offers, and how they are labelled.
import type { Cadence } from './types'

export const CADENCES = [
  'biweekly',
  'monthly',
] as const satisfies readonly Cadence[]

// Record<Cadence, string> keeps this exhaustive; the widened alias lets
// cadenceLabel look up a value the union does not cover.
const LABELS: Record<Cadence, string> = {
  biweekly: 'Biweekly',
  monthly: 'Monthly',
}
const LOOKUP: Record<string, string | undefined> = LABELS

// Falls back to the raw value so a cadence the API adds before this build
// ships still renders something.
export function cadenceLabel(cadence: string): string {
  return LOOKUP[cadence] ?? cadence
}
